(function () {
  'use strict';

  var FALLBACK_COLLECTION = 'best-sellers';
  var RESULTS_CAP = 20;

  var INTENT_TITLES = {
    wealth:      'Your Wealth & Abundance Collection',
    love:        'Your Love & Relationships Collection',
    health:      'Your Health & Vitality Collection',
    luck:        'Your Luck & Fortune Collection',
    protection:  'Your Protection Collection',
    peace:       'Your Peace & Calm Collection',
    career:      'Your Career & Success Collection',
    spirituality:'Your Spiritual Growth Collection'
  };

  var ZODIAC_TAGS = {
    aries: 'Aries', taurus: 'Taurus', gemini: 'Gemini', cancer: 'Cancer',
    leo: 'Leo', virgo: 'Virgo', libra: 'Libra', scorpio: 'Scorpio',
    sagittarius: 'Sagittarius', capricorn: 'Capricorn', aquarius: 'Aquarius', pisces: 'Pisces'
  };

  var KUNDALI_RUDRAKSHA = {
    aries: '3-mukhi-rudraksha', taurus: '6-mukhi-rudraksha', gemini: '4-mukhi-rudraksha',
    cancer: '2-mukhi-rudraksha', leo: '5-mukhi-rudraksha', virgo: '4-mukhi-rudraksha',
    libra: '6-mukhi-rudraksha', scorpio: '3-mukhi-rudraksha', sagittarius: '5-mukhi-rudraksha',
    capricorn: '7-mukhi-rudraksha', aquarius: '7-mukhi-rudraksha', pisces: '5-mukhi-rudraksha'
  };

  var KUNDALI_BRACELET_ZODIAC = {
    aries: ['protection', 'success'], taurus: ['money', 'peace'], gemini: ['success', 'peace'],
    cancer: ['love', 'peace'], leo: ['success', 'money'], virgo: ['health', 'peace'],
    libra: ['love', 'peace'], scorpio: ['protection', 'success'], sagittarius: ['success', 'money'],
    capricorn: ['money', 'success'], aquarius: ['peace', 'success'], pisces: ['peace', 'love']
  };

  var KUNDALI_BRACELET_HANDLES = {
    money: 'raw-pyrite-bracelet-for-wealth',
    love: 'rose-quartz-stone-bracelet',
    protection: 'karungali-bracelet-natural-ebony-wood-beads-govt-certified',
    health: 'karungali-bracelet-natural-ebony-wood-beads-govt-certified',
    success: 'money-magnet-bracelet-with-pyrite-tiger-eye-citrine-aventurine-beads',
    peace: 'karungali-damru-bracelet-with-rudraksha'
  };

  var MATERIAL_COLLECTIONS = {
    rudraksha: 'rudraksha',
    karungali: 'karungali',
    pyrite:    'pyrite'
  };

  var GENDER_COLLECTIONS = {
    him: 'spiritual-jewellery-for-men',
    her: 'spiritual-jewellery-for-women'
  };

  var state = {
    currentStep: 1,
    answers: {
      intent: null, gender: null, material: null, dob: null, tob: null, pob: null
    }
  };

  var els = {};
  var locationDebounce = null;

  function getTotalSteps() {
    return state.answers.material === 'kundali' ? 4 : 3;
  }

  function init() {
    els.popup = document.querySelector('[data-hmc-popup]');
    if (!els.popup) return;

    els.overlay   = els.popup.querySelector('[data-hmc-overlay]');
    els.panel     = els.popup.querySelector('[data-hmc-panel]');
    els.progress  = els.popup.querySelector('[data-hmc-progress]');
    els.stepLabel = els.popup.querySelector('[data-hmc-step-label]');
    els.nextBtn   = els.popup.querySelector('[data-hmc-next]');
    els.quizBody  = els.popup.querySelector('[data-hmc-quiz-body]');

    bindEvents();
  }

  function bindEvents() {
    document.querySelectorAll('[data-hmc-open]').forEach(function (btn) {
      btn.addEventListener('click', openPopup);
    });

    els.popup.querySelectorAll('[data-hmc-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    if (els.overlay) els.overlay.addEventListener('click', closePopup);

    var startBtn = els.popup.querySelector('[data-hmc-start]');
    if (startBtn) startBtn.addEventListener('click', startQuiz);

    if (els.nextBtn) els.nextBtn.addEventListener('click', nextStep);

    els.popup.querySelectorAll('[data-hmc-back]').forEach(function (btn) {
      btn.addEventListener('click', prevStep);
    });

    var resultsBackBtn = els.popup.querySelector('[data-hmc-results-back]');
    if (resultsBackBtn) resultsBackBtn.addEventListener('click', backFromResults);

    var skipBtn = els.popup.querySelector('[data-hmc-skip]');
    if (skipBtn) skipBtn.addEventListener('click', revealProducts);

    els.popup.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', handleRadioChange);
    });

    var dobInput = els.popup.querySelector('[data-hmc-dob]');
    if (dobInput) {
      dobInput.addEventListener('input', function () {
        state.answers.dob = this.value || null;
        updateContinueState();
      });
    }

    var tobInput = els.popup.querySelector('[data-hmc-tob]');
    if (tobInput) {
      tobInput.addEventListener('change', function () {
        state.answers.tob = this.value || null;
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && els.popup.getAttribute('aria-hidden') === 'false') {
        closePopup();
      }
    });

    setupLocationAutocomplete();
  }

  function handleRadioChange() {
    var fieldName = this.name.replace('hmc-', '');
    state.answers[fieldName] = this.value;

    var container = this.closest('[data-field]');
    if (container) {
      container.querySelectorAll('.hmc-card').forEach(function (card) {
        card.classList.remove('is-selected');
      });
      this.closest('.hmc-card').classList.add('is-selected');
    }

    if (fieldName === 'material') {
      var total = getTotalSteps();
      if (els.stepLabel) els.stepLabel.textContent = 'STEP ' + state.currentStep + ' OF ' + total;
      if (els.progress) els.progress.style.width = (state.currentStep / total * 100) + '%';
    }

    updateContinueState();
  }

  function openPopup() {
    els.popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    showScreen('intro');
  }

  function closePopup() {
    els.popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    resetQuiz();
  }

  function resetQuiz() {
    state.currentStep = 1;
    state.answers = {
      intent: null, gender: null, material: null, dob: null, tob: null, pob: null
    };

    els.popup.querySelectorAll('input[type="radio"]').forEach(function (r) {
      r.checked = false;
    });
    els.popup.querySelectorAll('.hmc-card.is-selected').forEach(function (card) {
      card.classList.remove('is-selected');
    });

    var dobInput = els.popup.querySelector('[data-hmc-dob]');
    if (dobInput) dobInput.value = '';
    var tobInput = els.popup.querySelector('[data-hmc-tob]');
    if (tobInput) tobInput.value = '';
    var pobInput = els.popup.querySelector('[data-hmc-pob]');
    if (pobInput) pobInput.value = '';
    var locList = els.popup.querySelector('[data-hmc-locations]');
    if (locList) locList.innerHTML = '';
  }

  function showScreen(name) {
    els.popup.querySelectorAll('[data-hmc-screen]').forEach(function (el) {
      if (el.dataset.hmcScreen === name) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  function startQuiz() {
    showScreen('quiz');
    showStep(1);
  }

  function showStep(num) {
    state.currentStep = num;
    var total = getTotalSteps();

    els.popup.querySelectorAll('[data-hmc-step]').forEach(function (el) {
      if (parseInt(el.dataset.hmcStep) === num) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });

    if (els.progress) els.progress.style.width = (num / total * 100) + '%';
    if (els.stepLabel) els.stepLabel.textContent = 'STEP ' + num + ' OF ' + total;

    updateContinueState();
    if (els.quizBody) els.quizBody.scrollTop = 0;
  }

  function updateContinueState() {
    if (!els.nextBtn) return;
    var s = state.currentStep;
    var a = state.answers;
    var ok = false;

    if      (s === 1) ok = !!a.intent;
    else if (s === 2) ok = !!a.gender;
    else if (s === 3) ok = !!a.material;
    else if (s === 4) ok = !!a.dob;

    els.nextBtn.disabled = !ok;
    els.nextBtn.style.opacity = ok ? '1' : '0.5';

    var isLastStep = (s === 3 && a.material && a.material !== 'kundali') || s === 4;
    els.nextBtn.textContent = isLastStep ? 'See My Matches →' : 'Continue →';
  }

  function nextStep() {
    var s = state.currentStep;

    if (s === 3) {
      if (state.answers.material === 'kundali') {
        showStep(4);
      } else {
        revealProducts();
      }
      return;
    }

    if (s === 4) {
      revealProducts();
      return;
    }

    showStep(s + 1);
  }

  function prevStep() {
    if (state.currentStep <= 1) {
      showScreen('intro');
    } else {
      showStep(state.currentStep - 1);
    }
  }

  function backFromResults() {
    showScreen('quiz');
    showStep(state.currentStep);
  }

  function getZodiac(dob) {
    var date = new Date(dob);
    if (isNaN(date.getTime())) return null;
    var month = date.getMonth() + 1;
    var day = date.getDate();
    if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return 'aries';
    if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return 'taurus';
    if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) return 'gemini';
    if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) return 'cancer';
    if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return 'leo';
    if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return 'virgo';
    if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) return 'libra';
    if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) return 'scorpio';
    if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) return 'sagittarius';
    if ((month === 12 && day >= 22) || (month === 1 && day <= 19)) return 'capricorn';
    if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) return 'aquarius';
    return 'pisces';
  }

  async function revealProducts() {
    if (els.nextBtn) {
      els.nextBtn.textContent = 'Finding your match…';
      els.nextBtn.disabled = true;
    }

    if (state.answers.material === 'kundali') {
      await scoreAndFilterKundali(state.answers);
    } else {
      await scoreAndFilterProducts(state.answers);
    }
    renderBanner(state.answers.intent);
    showScreen('results');
  }

  function renderBanner(intent) {
    var banner = els.popup.querySelector('[data-hmc-banner]');
    if (!banner) return;
    var title = INTENT_TITLES[intent] || 'Your Personal Collection';
    banner.innerHTML =
      '<div class="hmc-banner__icon">🪶</div>'
      + '<p class="hmc-banner__label">YOUR SACRED MATCH</p>'
      + '<h3 class="hmc-banner__title">' + escapeHtml(title) + '</h3>'
      + '<p class="hmc-banner__sub">Personalised for your intentions &amp; lifestyle by KarmaSahayaka</p>';
  }

  function getProductTags(product) {
    if (Array.isArray(product.tags)) return product.tags;
    return product.tags ? product.tags.split(',').map(function (t) { return t.trim(); }) : [];
  }

  function buildCollectionList(answers) {
    var collections = [];
    // spirituality has no collection — omitting it shows all products as the base
    if (answers.intent && answers.intent !== 'spirituality') {
      collections.push(answers.intent);
    }
    if (MATERIAL_COLLECTIONS[answers.material]) {
      collections.push(MATERIAL_COLLECTIONS[answers.material]);
    }
    if (GENDER_COLLECTIONS[answers.gender]) {
      collections.push(GENDER_COLLECTIONS[answers.gender]);
    }
    return collections;
  }

  async function scoreAndFilterProducts(answers) {
    var grid = els.popup.querySelector('[data-hmc-products]');
    if (!grid) return;
    grid.innerHTML = '<p class="hmc-loading">Finding your match…</p>';

    try {
      var collections = buildCollectionList(answers);
      var matched = [];

      if (!collections.length) {
        // No collections to filter by (e.g. spirituality + any material + any gender) — show all products
        var allRes = await fetch('/products.json?limit=250').catch(function () { return null; });
        var allData = allRes && allRes.ok ? await allRes.json() : { products: [] };
        matched = (allData.products || []).slice(0, RESULTS_CAP);
      } else {
        var responses = await Promise.all(
          collections.map(function (handle) {
            return fetch('/collections/' + handle + '/products.json?limit=250')
              .then(function (r) { return r.ok ? r.json() : { products: [] }; })
              .catch(function () { return { products: [] }; });
          })
        );

        var counts = {};
        var productMap = {};
        responses.forEach(function (data) {
          (data.products || []).forEach(function (p) {
            counts[p.id] = (counts[p.id] || 0) + 1;
            productMap[p.id] = p;
          });
        });

        var products = Object.keys(counts).map(function (id) {
          return { product: productMap[id], score: counts[id] };
        });

        products.sort(function (a, b) { return b.score - a.score; });
        matched = products.slice(0, RESULTS_CAP).map(function (item) { return item.product; });
      }

      if (!matched.length) {
        matched = await fetchFallbackProducts();
      }

      if (!matched.length) {
        grid.innerHTML = '<p class="hmc-no-products">No products found. Try adjusting your selections.</p>';
        return;
      }

      grid.innerHTML = matched.map(function (p) { return buildProductCard(p); }).join('');
      grid.querySelectorAll('[data-hmc-atc]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          addToCart(this.dataset.variantId, this);
        });
      });
    } catch (e) {
      grid.innerHTML = '<p class="hmc-no-products">Could not load products. Please try again.</p>';
    }
  }

  async function scoreAndFilterKundali(answers) {
    var grid = els.popup.querySelector('[data-hmc-products]');
    if (!grid) return;
    grid.innerHTML = '<p class="hmc-loading">Reading your birth chart…</p>';

    try {
      // --- Part 1: Zodiac-based Kundali products ---
      var zodiac = answers.dob ? getZodiac(answers.dob) : null;
      var handles = [];

      if (zodiac) {
        var rudrakshaHandle = KUNDALI_RUDRAKSHA[zodiac];
        if (rudrakshaHandle) handles.push(rudrakshaHandle);

        var braceletPurposes = KUNDALI_BRACELET_ZODIAC[zodiac] || [];
        braceletPurposes.forEach(function (purpose) {
          var handle = KUNDALI_BRACELET_HANDLES[purpose];
          if (handle && handles.indexOf(handle) === -1) handles.push(handle);
        });
      }

      var kundaliProducts = [];
      if (handles.length) {
        var handleResults = await Promise.all(
          handles.map(function (handle) {
            return fetch('/products/' + handle + '.js')
              .then(function (r) { return r.ok ? r.json() : null; })
              .catch(function () { return null; });
          })
        );

        handleResults.forEach(function (product) {
          if (!product) return;
          // /products/{handle}.js returns prices in paise — convert to rupees
          if (product.variants) {
            product.variants = product.variants.map(function (v) {
              return Object.assign({}, v, {
                price: (v.price / 100).toFixed(2),
                compare_at_price: v.compare_at_price ? (v.compare_at_price / 100).toFixed(2) : null
              });
            });
          }
          // /products/{handle}.js returns images as plain URL strings — wrap in {src} objects
          if (product.images && typeof product.images[0] === 'string') {
            product.images = product.images.map(function (src) { return { src: src }; });
          }
          kundaliProducts.push(product);
        });
      }

      // --- Part 2: Intent + gender collection products (same as normal path) ---
      var collectionProducts = [];
      var collections = buildCollectionList(answers); // kundali has no material collection
      var colResponses = await Promise.all(
        collections.map(function (handle) {
          return fetch('/collections/' + handle + '/products.json?limit=250')
            .then(function (r) { return r.ok ? r.json() : { products: [] }; })
            .catch(function () { return { products: [] }; });
        })
      );

      var counts = {};
      var productMap = {};
      colResponses.forEach(function (data) {
        (data.products || []).forEach(function (p) {
          counts[p.id] = (counts[p.id] || 0) + 1;
          productMap[p.id] = p;
        });
      });

      var scored = Object.keys(counts).map(function (id) {
        return { product: productMap[id], score: counts[id] };
      });
      scored.sort(function (a, b) { return b.score - a.score; });
      collectionProducts = scored.slice(0, RESULTS_CAP).map(function (item) { return item.product; });

      // Remove from collection products any already shown as Kundali
      var kundaliIds = {};
      kundaliProducts.forEach(function (p) { kundaliIds[p.id] = true; });
      collectionProducts = collectionProducts.filter(function (p) { return !kundaliIds[p.id]; });

      // --- Render: Kundali products first, then Your Match products ---
      if (!kundaliProducts.length && !collectionProducts.length) {
        var fallback = await fetchFallbackProducts();
        if (!fallback.length) {
          grid.innerHTML = '<p class="hmc-no-products">No products found. Try adjusting your selections.</p>';
          return;
        }
        grid.innerHTML = fallback.map(function (p) { return buildProductCard(p, 'Your Match'); }).join('');
      } else {
        grid.innerHTML =
          kundaliProducts.map(function (p) { return buildProductCard(p, 'Kundali'); }).join('') +
          collectionProducts.map(function (p) { return buildProductCard(p, 'Your Match'); }).join('');
      }

      grid.querySelectorAll('[data-hmc-atc]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          addToCart(this.dataset.variantId, this);
        });
      });
    } catch (e) {
      grid.innerHTML = '<p class="hmc-no-products">Could not load products. Please try again.</p>';
    }
  }

  async function fetchFallbackProducts() {
    try {
      var res = await fetch('/collections/' + FALLBACK_COLLECTION + '/products.json?limit=' + RESULTS_CAP);
      if (!res.ok) return [];
      var data = await res.json();
      return data.products || [];
    } catch (e) {
      return [];
    }
  }

  function buildProductCard(product, badge) {
    badge = badge || 'Your Match';
    var variants  = product.variants || [];
    var firstVariant     = variants[0];
    var availableVariant = variants.find(function (v) { return v.available; });
    var variant   = availableVariant || firstVariant;
    var available = !!availableVariant;
    var sale      = variant ? parseFloat(variant.price).toFixed(0) : '0';
    var compare   = (variant && variant.compare_at_price) ? parseFloat(variant.compare_at_price).toFixed(0) : null;
    var img       = product.images && product.images[0] ? product.images[0].src : '';
    var variantId = variant ? variant.id : '';

    var productUrl = '/products/' + product.handle;
    return '<div class="hmc-product-card">'
      + '<a href="' + productUrl + '" target="_blank" rel="noopener" class="hmc-product-card__img-wrap">'
      + '<span class="hmc-product-card__badge">' + escapeHtml(badge) + '</span>'
      + (img ? '<img src="' + img + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '')
      + '</a>'
      + '<div class="hmc-product-card__info">'
      + '<a href="' + productUrl + '" target="_blank" rel="noopener" class="hmc-product-card__title-link">'
      + '<h4 class="hmc-product-card__title">' + escapeHtml(product.title) + '</h4>'
      + '</a>'
      + '<div class="hmc-product-card__price">'
      + '<span class="hmc-price-sale">₹' + sale + '</span>'
      + (compare && Number(compare) > Number(sale) ? '<span class="hmc-price-compare">₹' + compare + '</span>' : '')
      + '</div>'
      + '<button class="hmc-atc-btn" data-hmc-atc data-variant-id="' + variantId + '"'
      + (available ? '' : ' disabled') + '>'
      + (available ? 'Add to Cart' : 'Sold Out')
      + '</button>'
      + '</div>'
      + '</div>';
  }

  async function addToCart(variantId, btn) {
    if (!variantId) return;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    var cartAddUrl = (window.routes && window.routes.cart_add_url)
      ? window.routes.cart_add_url + '.js'
      : '/cart/add.js';
    try {
      var res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (res.ok) {
        btn.textContent = '✓ Added!';
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer(true);
        } else {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (typeof window.updateCartCount === 'function') {
                window.updateCartCount(cart.item_count);
              } else {
                var countEl = document.querySelector('[data-cart-count]');
                if (countEl) countEl.textContent = cart.item_count < 100 ? cart.item_count : '99+';
              }
            });
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        }, 2000);
      } else {
        var errData = await res.json().catch(function () { return {}; });
        btn.textContent = errData.description || 'Error';
        btn.disabled = false;
      }
    } catch (e) {
      btn.textContent = 'Error';
      btn.disabled = false;
    }
  }

  function setupLocationAutocomplete() {
    var pobInput = els.popup && els.popup.querySelector('[data-hmc-pob]');
    var locList  = els.popup && els.popup.querySelector('[data-hmc-locations]');
    if (!pobInput || !locList) return;

    pobInput.addEventListener('input', function () {
      clearTimeout(locationDebounce);
      var query = this.value.trim();
      state.answers.pob = query || null;
      if (query.length < 3) { locList.innerHTML = ''; return; }
      locationDebounce = setTimeout(function () {
        fetchLocations(query, locList, pobInput);
      }, 300);
    });
  }

  async function fetchLocations(query, locList, pobInput) {
    try {
      var res = await fetch(
        'https://nominatim.openstreetmap.org/search?format=json&q=' + encodeURIComponent(query) + '&limit=5',
        { headers: { 'User-Agent': 'Karmaveda-Quiz' } }
      );
      if (!res.ok) return;
      var results = await res.json();
      locList.innerHTML = '';
      results.forEach(function (loc) {
        var name = String(loc.display_name || '').substring(0, 100);
        var item = document.createElement('div');
        item.className = 'hmc-location-item';
        item.textContent = name;
        item.addEventListener('click', function () {
          pobInput.value = name;
          state.answers.pob = name;
          locList.innerHTML = '';
        });
        locList.appendChild(item);
      });
    } catch (e) { /* ignore */ }
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  document.addEventListener('DOMContentLoaded', init);
})();
